import React from 'react';

import './header.scss';
import Tabs from './tabs';
import useGlobal from '../../../store';

const Header = () => {

  const [ globalState, globalActions ] = useGlobal();
  const { sign } = globalActions;

  const isAuthPage = window.location.href.includes('/sign');

  return (
  
    <header className="flex items-center justify-between">

      <div className="header__panel">

        <h1 className="admin-panel__div_name">Панель администрирования</h1>

      </div>
      
      <div id="header__tabs">
        
        { window.location.pathname !== "/sign" && <Tabs /> }
      
      </div>
            
      <div className="header__user flex justify-end">
        { !isAuthPage &&
          <div 
            onClick = { sign.Out }
            style = {{ marginRight: '20px', color: 'red', cursor: 'pointer' }}
          >
            выйти
          </div>
        }
      </div>

    </header>
  
  );
  
}
  
export default Header;